import { createReducer } from '@reduxjs/toolkit';
import { getAllTemplates, setSelectedTemplateId } from 'redux/actions/course-templates';
import { initialRootState } from '.';

const courseTemplatesReducer = createReducer(initialRootState, builder => {
  builder
    .addCase(setSelectedTemplateId, (state, action) => {
      state.app.courseTemplates.selectedTemplateId = action.payload;
    })
    .addCase(getAllTemplates.pending, (state, action) => {
      state.app.courseTemplates.isLoading = true;
    })
    .addCase(getAllTemplates.fulfilled, (state, action) => {
      state.app.courseTemplates.isLoading = false;
      state.models.courseTemplates = action.payload;
    });
});

export default courseTemplatesReducer;
